import { useEffect, useState } from "react";
import { getProductsBySubCategory } from "../../../api/pagination";


const useSubCategoryDetails = (initialDetails) => {
    const [details, setDetails] = useState(initialDetails || null);
    const [skus, setSkus] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialDetails) {
            setDetails(initialDetails);
        }
    }, [initialDetails]);


    useEffect(() => {
        if (!details?._id) return;

        setLoading(true);

        getProductsBySubCategory(details._id, (response) => {
            if (response?.status === 200) {
                setSkus(response?.data?.data ?? []);
            }
            setLoading(false);
        });
    }, [details?._id]);

    return {
        details,
        skus,
        loading,
    };
};

export default useSubCategoryDetails;
